import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/scale-subtle.css'

export default function initTippy() {
    tippy('[data-tippy-content]', {
        theme: 'greentec',
        animation: 'scale-subtle',
        zIndex: 10
    });
}